import { Trade } from '../../types/entities';

export interface RecentTradeState {
  loading: boolean;
  loaded: boolean;
  pending: boolean;
  error?: string | undefined;
  trades: Trade[];
}

export const initialState: RecentTradeState = {
  loading: false,
  loaded: false,
  pending: false,
  trades: []
};
